module.exports = __webpack_public_path__ + "static/media/Apple iPhone 7 Plus Matte Black.7db7f883.png";